/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2022
 */

export default class FaceConfig {
  static UPDATE = 'face-update'
  static POST_UPDATE = 'face-post-update'

  constructor ({ hair, face, eyebrows, eyes, nose, mouth, body }) {
    this.data = { hair, face, eyebrows, eyes, nose, mouth, body }
  }

  static init (eventBus) {
    const input = document.getElementById('onboarding-face')
    const x = FaceConfig.parse(input.value)
    if (x) {
      FaceConfig.singleton = new FaceConfig(x)
    } else {
      FaceConfig.singleton = new FaceConfig(FaceConfig.changes())
    }
    eventBus.on(FaceConfig.constructor.name, FaceConfig.UPDATE, (changes, cb) => {
      for (const [k, v] of Object.entries(changes)) {
        FaceConfig.singleton.data[k] = v
      }
      input.value = FaceConfig.singleton.toHash()
      if (cb) cb(input.value)
    })
  }

  static parse (input) {
    const x = /^h(\d)-f(\d)-b(\d)-e(\d)-n(\d)-m(\d)-o(\d)$/.exec(input)
    if (x) {
      const [hair, face, eyebrows, eyes, nose, mouth, body] = x.slice(1).map((v) => +v)
      return { hair, face, eyebrows, eyes, nose, mouth, body }
    }
  }

  static get (part) {
    if (part) return FaceConfig.singleton.data[part]
    else return FaceConfig.singleton.data
  }

  static changes () {
    const r = () => Math.floor(Math.random() * 4)
    const s = () => Math.floor(Math.random() * 2)
    return { hair: r(), face: r(), eyebrows: r(), eyes: r(), nose: r(), mouth: r(), body: s() }
  }

  toHash () {
    const { hair, face, eyebrows, eyes, nose, mouth, body } = this.data
    return `h${hair}-f${face}-b${eyebrows}-e${eyes}-n${nose}-m${mouth}-o${body}`
  }
}
